import { type RouteRecordRaw } from 'vue-router'

import { useAuthStore } from 'stores/receiver/account/auth/auth'
import { useTwoFactorStore } from 'stores/receiver/account/security/twoFactor'
import { useUserStore } from 'stores/receiver/account/user/user'

export const authRoutes: RouteRecordRaw[] = [
  // SIGN IN
  {
    path: '/login',
    component: () => import('layouts/receiver/MainLayout.vue'),
    children: [
      {
        path: '',
        name: 'login',
        component: () => import('pages/receiver/account/login/LoginPage.vue'),
        meta: {
          requiresAuth: false,
        },
      },
      {
        path: 'check',
        name: 'login-check',
        component: () => import('pages/receiver/account/login/LoginCheck.vue'),
        meta: {
          requiresAuth: false,
        },
      },
      {
        path: 'two-factor',
        name: 'login-two-factor-choice',
        component: () => import('pages/common/login/TwoFactorChoicePage.vue'),
        props: {
          useAuthStore: useAuthStore,
        },
        meta: {
          requiresAuth: false,
        },
      },
      {
        path: 'two-factor/:type',
        name: 'login-two-factor',
        component: () => import('pages/common/login/TwoFactorPage.vue'),
        props: {
          useAuthStore,
          useTwoFactorStore,
          useUserStore,
        },
        meta: {
          requiresAuth: false,
        },
      },
    ],
  },
  // SIGN UP Check
  {
    path: '/sign-up',
    component: () => import('layouts/receiver/MainLayout.vue'),
    children: [
      {
        path: '',
        name: 'sign-up',
        component: () => import('pages/receiver/account/login/SignUpPage.vue'),
        meta: {
          requiresAuth: false,
        },
      },
    ],
  },
  {
    path: '/sign-up',
    component: () => import('layouts/receiver/CleanLayout.vue'),
    children: [
      {
        path: 'profile',
        name: 'sign-up-profile',
        component: () =>
          import('pages/receiver/account/login/SignUpQuestions.vue'),
        meta: {
          requiresAuth: true,
        },
      },
    ],
  },
  // PASSWORD RECOVERY
  {
    path: '/password-recovery',
    component: () => import('layouts/receiver/MainLayout.vue'),
    children: [
      {
        path: '',
        name: 'password-recovery',
        component: () =>
          import(
            'pages/receiver/account/security/passwordRecovery/EmailStep.vue'
          ),
        meta: {
          requiresAuth: false,
        },
      },
      {
        path: 'validation',
        name: 'password-recovery-validation',
        component: () =>
          import(
            'pages/receiver/account/security/passwordRecovery/ValidationStep.vue'
          ),
        meta: {
          requiresAuth: false,
        },
      },
      {
        path: 'update',
        name: 'password-recovery-update',
        component: () =>
          import(
            'pages/receiver/account/security/passwordRecovery/NewPasswordStep.vue'
          ),
        meta: {
          requiresAuth: false,
        },
      },
    ],
  },
]
